// extracted by mini-css-extract-plugin
module.exports = {"panel":"ImagePanel_panel__e2RtE","content":"ImagePanel_content__LopcF","img":"ImagePanel_img__3ufA_","box":"ImagePanel_box__3Nvd2"};